import React from 'react';
import PropTypes from 'prop-types';

// material-ui components
import withStyles from '@material-ui/core/styles/withStyles';

// @material-ui/icons
import Student from '@material-ui/icons/Mood';
import Work from '@material-ui/icons/Work';

// core components
import GridContainer from 'components/Grid/GridContainer';
import ItemGrid from 'components/Grid/ItemGrid';
import PricingCard from 'components/Cards/PricingCard';
import Button from 'components/CustomButtons/Button';
import ErrorBoundaries from 'components/Wrapper/ErrorBoundaries';
import profilePageStyle from 'views/Auth/style/profilePageStyle';

class ProfilePage extends React.Component {
  handleClick = (type, urlType) =>
    this.props.history.push({
      pathname: `/auth/${urlType}`,
      state: {
        type,
        source: this.props.match.params.source ? this.props.match.params.source : 'VVMT',
      },
    });

  render() {
    const { classes } = this.props;

    return (
      <ErrorBoundaries>
        <div className={classes.content}>
          <div className={classes.container}>
            <GridContainer justifyContent='center'>
              <ItemGrid xs={12}>
                <h2 className={classes.title}>Choisissez votre profil</h2>
              </ItemGrid>
            </GridContainer>
            <GridContainer justifyContent='center'>
              <ItemGrid xs={12} sm={6} md={4}>
                <PricingCard
                  price='ÉLÈVE'
                  description='Tu es collégien en REP et tu cherches un stage ?'
                  icon={Student}
                  iconColor='red'
                  footer={
                    <Button
                      round
                      color='white'
                      customClass={classes.button}
                      onClick={() => this.handleClick('student', 'eleve')}>
                      Je trouve un stage
                    </Button>
                  }
                />
              </ItemGrid>
              <ItemGrid xs={12} sm={6} md={4}>
                <PricingCard
                  price='TUTEUR'
                  description='Proposez un stage de 5 jours à un collégien'
                  icon={Work}
                  iconColor='purple'
                  footer={
                    <Button
                      round
                      color='white'
                      customClass={classes.button}
                      onClick={() => this.handleClick('pro', 'professionnel')}>
                      Je propose un stage
                    </Button>
                  }
                />
              </ItemGrid>
            </GridContainer>
            <GridContainer justifyContent='center'>
              <ItemGrid xs={12} sm={6} md={4}>
                <PricingCard
                  price='COLLÈGE'
                  description='Enseignants, CPE : suivez les candidatures de vos élèves'
                  iconColor='pink'
                  footer={
                    <Button
                      round
                      color='white'
                      customClass={classes.button}
                      onClick={() => this.handleClick('college', 'college')}>
                      Sélectionner
                    </Button>
                  }
                />
              </ItemGrid>
              <ItemGrid xs={12} sm={6} md={4}>
                <PricingCard
                  price='RH'
                  description="Gérez l'ensemble des stages proposés par vos collaborateurs"
                  iconColor='yellow'
                  footer={
                    <Button
                      round
                      color='white'
                      customClass={classes.button}
                      onClick={() => this.handleClick('hr', 'entreprise')}>
                      Sélectionner
                    </Button>
                  }
                />
              </ItemGrid>
            </GridContainer>
          </div>
        </div>
      </ErrorBoundaries>
    );
  }
}

ProfilePage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(profilePageStyle)(ProfilePage);
